export default __webpack_public_path__ + "static/media/defaultUser.33800973.jpg";